import { BaseConst } from './baseConst';

export class CmObjectConst extends BaseConst {

    // 对象
    // static ParentObject = 'ParentObject';
    static ContainChildObjects = 'ContainChildObjects';
    static ContainElements = 'ContainElements';
    static ParentObjectID = 'ParentObjectID';
    static ObjectType = 'ObjectType';
    static IsVirtual = 'IsVirtual';

    // 唯一性约束
    static ContainConstraints = 'ContainConstraints';
    static ConstraintMessage = 'ConstraintMessage';
    static Type = 'Type';
    static ElementList = 'ElementList';

    // 权限
    static AuthFieldInfos = 'AuthFieldInfos';

    static MdRefInfo_ID = 'ID';
    static MdRefInfo_Name = 'Name';
    // 操作
    static DtmBeforeSave = 'DtmBeforeSave';
    static DtmAfterSave = 'DtmAfterSave';
    static DtmAfterModify = 'DtmAfterModify';
    static DtmAfterCreate = 'DtmAfterCreate';
    /**
     * 持久化构件
     */
    static RepositoryComps = 'RepositoryComps';
    static RequestElements = 'RequestElements';

}
